// Award messages (`notification_body`) can be authored by any participant via peer-to-peer
// awards, then get rendered on another participant's page via dangerouslySetInnerHTML — an
// unsanitized pass-through here is stored XSS. No sanitizer library is used (see ICOV3-1609
// spec), so this allowlist must stay conservative: prefer dropping a tag/attribute over
// guessing it's safe.
const ALLOWED_TAGS = new Set(["B", "STRONG", "I", "EM", "U", "P", "DIV", "SPAN", "BR", "A", "UL", "OL", "LI"]);
const STRIP_ENTIRELY = new Set(["SCRIPT", "STYLE", "IFRAME", "OBJECT", "EMBED", "SVG", "MATH", "LINK", "META"]);
const SAFE_HREF = /^(https?:|mailto:)/i;

const sanitizeChildren = (parent) => {
    Array.from(parent.childNodes).forEach((node) => sanitizeNode(node, parent));
};

const sanitizeNode = (node, parent) => {
    if (node.nodeType === Node.TEXT_NODE) return;

    if (node.nodeType !== Node.ELEMENT_NODE) {
        parent.removeChild(node);
        return;
    }

    // Foreign-content elements (SVG/MathML) keep a lowercase tagName instead of
    // being auto-uppercased like ordinary HTML elements — normalize so the
    // allowlist/stoplist checks below can't be bypassed by namespace.
    const tag = node.tagName.toUpperCase();

    if (STRIP_ENTIRELY.has(tag)) {
        parent.removeChild(node);
        return;
    }

    const href = tag === "A" ? node.getAttribute("href") : null;

    sanitizeChildren(node);

    if (!ALLOWED_TAGS.has(tag)) {
        while (node.firstChild) parent.insertBefore(node.firstChild, node);
        parent.removeChild(node);
        return;
    }

    Array.from(node.attributes).forEach((attr) => node.removeAttribute(attr.name));

    if (tag === "A" && href && SAFE_HREF.test(href)) {
        node.setAttribute("href", href);
        node.setAttribute("rel", "noopener noreferrer");
        node.setAttribute("target", "_blank");
    }
};

export const sanitizeAwardMessage = (html) => {
    if (!html) return "";

    const doc = new DOMParser().parseFromString(String(html), "text/html");
    sanitizeChildren(doc.body);
    return doc.body.innerHTML;
};
